export const AG_GRID_ENTERPRISE_LICENSE_KEY =
  import.meta.env.VITE_AG_GRID_ENTERPRISE_LICENSE_KEY || "";
